var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_2373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3749 7.53333L12.3416 7.18333L10.7666 3.475C10.4833 2.8 9.51661 2.8 9.23327 3.475L7.65827 7.19167L3.63327 7.53333C2.89994 7.59167 2.59994 8.50833 3.15827 8.99167L6.21661 11.6417L5.29994 15.575C5.13327 16.2917 5.90827 16.8583 6.5416 16.475L9.99994 14.3917L13.4583 16.4833C14.0916 16.8667 14.8666 16.3 14.6999 15.5833L13.7833 11.6417L16.8416 8.99167C17.3999 8.50833 17.1083 7.59167 16.3749 7.53333ZM9.99994 12.8333V5.08333L11.4249 8.45L15.0749 8.76667L12.3083 11.1667L13.1416 14.7333L9.99994 12.8333Z",
    fill: "#FF8400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_2373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star_half.a67e176386f66b930182b2ca4940f09f.svg";
export { ForwardRef as ReactComponent };